// extracted by mini-css-extract-plugin
export var active = "_a1-c";
export var activeIndicator = "_a1-7";
export var animate = "_a1-b";
export var contentWidthTabs = "_a1-5";
export var disabled = "_a1-d";
export var flat = "_a1-1";
export var fullWidth = "_a1-3";
export var lg = "_a1-a";
export var md = "_a1-9";
export var redoButtonTabGroup = "_a1-0";
export var sm = "_a1-8";
export var tabButton = "_a1-4";
export var tabButtonsContainer = "_a1-2";
export var xs = "_a1-6";